import { render } from "./AddToBoardConfirmationModal.vue?vue&type=template&id=05b6dde1&scoped=true"
import script from "./AddToBoardConfirmationModal.vue?vue&type=script&lang=js"
export * from "./AddToBoardConfirmationModal.vue?vue&type=script&lang=js"

import "./AddToBoardConfirmationModal.vue?vue&type=style&index=0&id=05b6dde1&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b6dde1"]])

export default __exports__